import Ajax from 'global/od/Ajax';

const { Modal } = window.od;

const nectarLegalLink = link => {
	if (link) {
		link.addEventListener('click', e => nectarCallContent(e, link));
	}
};

const nectarCallContent = async (event, link) => {
	event.preventDefault();
	const url = link.getAttribute('href');

	if (url) {
		const page = await Ajax.get(url);
		const node = document.createRange().createContextualFragment(page.data);
		const content = node.querySelector('.nectarTerms');

		displayModal(content);
	}
};

const displayModal = data => {
	const modalId = document.querySelector('#nectarModal');
	const elem = document.querySelector('#nectarTermsAndConditionsModalContent');

	if (modalId && elem) {
		const modal = new Modal(modalId);
		elem.appendChild(data);
		modal.show();
	}

	modalId
		.querySelector('.close')
		.addEventListener('click', () => elem.removeChild(data));
};

export default nectarLegalLink;
